export const defaultQuotationTemplate = (baseDate: Date = new Date()) => `{
  "quotationName": "Sample Quotation",
  "submissionDateTime": "${baseDate.toISOString()}",
  "validityStartDateTime": "${baseDate.toISOString()}",
  "validityEndDateTime": "${new Date(baseDate.getTime() + 30 * 24 * 60 * 60 * 1000).toISOString()}",
  "quotationStatus": "DRAFT",
  "quotationProcess": "SELF_CARE",
  "requestor": {
    "commercialName": "ACME SARL"
  },
  "provider": {
    "commercialName": "My Provider Company"
  },
  "startLocation": {
    "location": {
      "address": {
        "addressLocality": "LA ROCHELLE",
        "addressRegion": "",
        "postOfficeBoxNumber": "B1235",
        "postalCode": "17000",
        "addressLines": [
          "131 Bd Pereire"
        ],
        "addressCountry": {
          "countryCode": "FR",
          "countryName": "FRANCE"
        }
      }
    },
    "plannedStartTimeRange": {
      "earliestDateTime": "${baseDate.toISOString()}",
      "latestDateTime": "${baseDate.toISOString()}"
    },
    "plannedEndTimeRange": {
      "earliestDateTime": "${baseDate.toISOString()}",
      "latestDateTime": "${baseDate.toISOString()}"
    }
  },
  "endLocation": {
    "location": {
      "address": {
        "addressLocality": "GENNEVILLIERS",
        "addressRegion": "Ile de france",
        "postOfficeBoxNumber": "",
        "postalCode": "92230",
        "addressLines": [
          "Rue du Fossé aux Loups 18"
        ],
        "addressCountry": {
          "countryCode": "FR",
          "countryName": "FRANCE"
        }
      },
      "specialCharacteristics": [
        {
          "specialCharacteristicType": "IS_RESIDENTIAL"
        }
      ]
    },
    "plannedStartTimeRange": {
      "earliestDateTime": "2024-12-10T00:00:00Z",
      "latestDateTime": "2024-12-19T00:00:00Z"
    },
    "plannedEndTimeRange": {
      "earliestDateTime": "2025-01-19T00:00:00Z",
      "latestDateTime": "2025-01-25T00:00:00Z"
    }
  },
  "batchesOfGoods": [
    {
      "codePackaging": "MGS_PALLET_PE1",
      "containerType": "PALLET",
      "dimensions": {
        "height": {
          "unit": "CMT",
          "value": 4
        },
        "length": {
          "unit": "CMT",
          "value": 120
        },
        "width": {
          "unit": "CMT",
          "value": 80
        }
      },
      "product": {
        "productDescription": "chiens",
        "specialCharacteristics": []
      },
      "quantity": {
        "value": 1
      },
      "weight": {
        "unit": "KGM",
        "value": 3
      }
    }
  ],
  "contacts": [
    {
      "role": "REQUESTOR",
      "persons": [
        {
          "email": "test@company.com",
          "telephone": "0123456789",
          "familyName": "TEST",
          "givenName": "Pola"
        }
      ]
    }
  ]
}`;